// "The 6-Second Search — a pgvector HNSW trap" — hybrid-search timeout incident short.
// Cold Compute / Neon kit. ~123s @ 30fps.
//
// GROUNDED in EAKC-MVP:
//   src/lib/rag/hybrid-search.ts / supabase migration for hybrid_search_document_chunks
//     (the vector pass: a CASE preference expression placed BEFORE `embedding <=> query`)
//   Postgres statement_timeout = 8s; observed query latency 6,013 ms → 701 ms (~8.6×)
//   error surfaced from logs: `canceling statement due to statement timeout · code 57014`
//     (was previously swallowed as a useless `[object Object]`)
//   pgvector HNSW only accelerates a PURE `ORDER BY embedding <=> query LIMIT k`;
//     any leading ORDER BY expression forces a sequential scan over ALL ~24,837 vectors.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05   chat timing out · error hidden as [object Object]
  reveal: { start: 150, duration: 510 }, //     0:05–0:22   the real error: statement timeout · 57014
  diagnosis: { start: 660, duration: 600 }, //  0:22–0:42   the ORDER BY — CASE sits before the distance op
  trap: { start: 1260, duration: 600 }, //      0:42–1:02   HNSW only serves a PURE distance sort → seq scan
  code: { start: 1860, duration: 720 }, //      1:02–1:26   the fix: nearest-K subquery, then re-sort outside
  payoff: { start: 2580, duration: 510 }, //    1:26–1:43   6,013 ms → 701 ms · ~8.6× faster
  lesson: { start: 3090, duration: 360 }, //    1:43–1:55   never put an expression before the distance op
  outro: { start: 3450, duration: 300 }, //     1:55–2:05
} as const;

export const TOTAL_DURATION = 3750; // 125s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
